import {useQueries} from "@tanstack/react-query";
import vehicleService from "../../../../../services/web/vehicle-service.js";
import userService from "../../../../../services/web/user-service.js";
import placeService from "../../../../../services/web/place-service.js";

const UseFetchData = (id) => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['vehicles'],
                queryFn: () => vehicleService.availableForMaintenance(),
            },
            {
                queryKey: ['conductors'],
                queryFn: () => userService.optionsWithoutSystem()
            },
            {
                queryKey: ['mechanics'],
                queryFn: () => placeService.getMechanics(id),
            }
        ]
    });

    return {vehicles: queries[0].data, conductors: queries[1].data, mechanics: queries[2].data}
};

export default UseFetchData;